import styled from 'styled-components'

import { poppins } from '@/components/common/fonts'

export const Area = styled.div`
  padding-top: 25px;
  padding-bottom: 25px;
  overflow: hidden;
`

export const AreaSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const AreaSectionTitle = styled.h2`
  margin: 0;
  margin-bottom: 16px;

  font-family: ${poppins.string};
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #222222;
`

export const AreaSectionSubTitle = styled.h3`
  margin: 0;
  margin-bottom: 15px;

  font-family: ${poppins.string};
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  color: #222222;
`
